document.addEventListener('DOMContentLoaded', () => {

    const header = document.querySelector('.exxtra-header-rebrand');

    if (!header) return;

    /* ==========================================
       Fixed Header
    ========================================== */

    if (header.dataset.sticky === 'true') {

        const wrapper = header.parentElement;

        const updateHeaderSpace = () => {

            if (!wrapper) return;

            wrapper.style.minHeight =
                `${header.getBoundingClientRect().height}px`;

        };

        /* Reserve space for the fixed header */
        updateHeaderSpace();

        /* Update automatically if header height changes */
        if (window.ResizeObserver) {

            const observer = new ResizeObserver(() => {
                updateHeaderSpace();
            });

            observer.observe(header);

        } else {

            window.addEventListener('resize', updateHeaderSpace);

        }

    }

    /* ==========================================
       Mobile Drawer
    ========================================== */

    const toggle = header.querySelector('.exxtra-header-rebrand__mobile-toggle');
    const drawer = header.querySelector('.exxtra-header-rebrand__drawer');

    if (toggle && drawer) {

        toggle.addEventListener('click', () => {

            drawer.classList.toggle('is-open');

            toggle.classList.toggle('is-active');

        });

        document.addEventListener('click', (event) => {

            if (
                !drawer.contains(event.target) &&
                !toggle.contains(event.target)
            ) {

                drawer.classList.remove('is-open');
                toggle.classList.remove('is-active');

            }

        });

    }

    /* ==========================================
       ESC closes mobile drawer
    ========================================== */

    document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape') {

            drawer?.classList.remove('is-open');
            toggle?.classList.remove('is-active');

        }

    });

    /* ==========================================
       Mega Menu Accessibility
    ========================================== */

    const megaItems = header.querySelectorAll('.has-mega');

    megaItems.forEach(item => {

        const trigger = item.querySelector('.exxtra-header-rebrand__link');
        const panel = item.querySelector('.exxtra-header-rebrand__mega');

        if (!trigger || !panel) return;

        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');

        item.addEventListener('mouseenter', () => {

            trigger.setAttribute('aria-expanded', 'true');

        });

        item.addEventListener('mouseleave', () => {

            trigger.setAttribute('aria-expanded', 'false');

        });

    });

});